module.exports = __webpack_public_path__ + "img/EG.8ddf02a4.svg";